import { render, staticRenderFns } from "./ComposerCart.vue?vue&type=template&id=4ae24ebb&scoped=true"
import script from "./ComposerCart.vue?vue&type=script&lang=js"
export * from "./ComposerCart.vue?vue&type=script&lang=js"
import style0 from "./ComposerCart.vue?vue&type=style&index=0&id=4ae24ebb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae24ebb",
  null
  
)

export default component.exports